import {StoreState} from "../../../app/models/states/AppStates";
import {
    ACTION_APP__CLEAR_LAST_STATE,
    ACTION_APP__LOCAL_CHANGE,
    ACTION_APP__RESTART
} from "../../../app/actions/Actions";
import {OverviewScreen} from './OverviewScreen';
import {connect} from "react-redux";
import {AppMainStates} from "../../../app/models/Constants";

const mapStateToProps = (state: StoreState) => {
    return {
        locale: state.appState.locale,
        locales: state.appState.locales,
        currentSelectedLink: state.overview.currentSelectedLink,

        appConfig: state.appState.appConfig,

        isInitialDisplay: (state.appState.lastMainState == AppMainStates.LOADING),

        data: state.overview.xmlObject,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLocaleChangeRequest: (newLocale: string) => {
            dispatch(ACTION_APP__LOCAL_CHANGE({newLocale}));
            dispatch(ACTION_APP__RESTART({}));
        },
        removeCurrentScreen: () => {
            dispatch(ACTION_APP__CLEAR_LAST_STATE({}));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OverviewScreen);